import { BaseColors as IBaseColors } from './colors';

export { default as colors } from './colors';

// types
export type BaseColors = IBaseColors;
